import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FEATURED_WORKS } from "../../data/site";
import { Reveal, RevealImage, SectionMark } from "./Reveal";

export const FeaturedWorks = () => (
    <section
        data-testid="featured-works"
        className="border-t border-white/[0.07] px-5 py-24 md:px-10 md:py-32"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="flex items-end justify-between">
                <Reveal>
                    <SectionMark>( Odabrani radovi )</SectionMark>
                </Reveal>
                <Reveal delay={0.1}>
                    <Link
                        to="/radovi"
                        data-testid="featured-works-all"
                        className="inline-flex items-center gap-2 border-b border-bone/25 pb-1 text-[11px] font-medium uppercase tracking-[0.26em] text-bone/80 transition-colors hover:border-bronze hover:text-bronze"
                    >
                        Svi radovi <ArrowUpRight size={14} strokeWidth={1.5} />
                    </Link>
                </Reveal>
            </div>

            <div className="mt-10 grid grid-cols-12 gap-3 md:mt-14 md:gap-5">
                <Reveal className="col-span-12 md:col-span-7 aspect-[4/3]">
                    <Link to="/radovi" data-testid="featured-work-0" className="group block h-full overflow-hidden">
                        <img src={FEATURED_WORKS[0].src} alt={FEATURED_WORKS[0].alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
                    </Link>
                </Reveal>
                <Reveal delay={0.1} className="col-span-12 md:col-span-5 aspect-[4/3] md:aspect-[3/4] md:mt-20">
                    <Link to="/radovi" data-testid="featured-work-1" className="group block h-full overflow-hidden">
                        <img src={FEATURED_WORKS[1].src} alt={FEATURED_WORKS[1].alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
                    </Link>
                </Reveal>
                <Reveal delay={0.15} className="col-span-12 md:col-span-8 md:col-start-3 aspect-[16/8]">
                    <Link to="/radovi" data-testid="featured-work-2" className="group block h-full overflow-hidden">
                        <img src={FEATURED_WORKS[2].src} alt={FEATURED_WORKS[2].alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);
